<template>
  <div
    v-show="snackIsActive"
    class="snack-container"
    :class="{ error: isErrorSnack }"
  >
    <div class="snack-wrapper">
      <div class="snack">
        <div class="snack-icon">
          <slot name="icon">
            <template v-if="isErrorSnack">
              <ErrorIcon />
            </template>
          </slot>
        </div>
        <div class="snack-text">
          {{ snackText }}
        </div>
        <div @click="close()" class="snack-close">
          <CloseIcon />
          <span class="close-text">ESC</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CloseIcon from "../../../public/img/icons/close.svg";
import ErrorIcon from "../../../public/img/icons/error.svg";
export default {
  name: "SnackBar",
  components: {
    CloseIcon,
    ErrorIcon,
  },
  computed: {
    snackIsActive() {
      return this.$store.getters.getSnackIsActive;
    },
    snackText() {
      return this.$store.getters.getSnackText;
    },
    snackType() {
      return this.$store.getters.getSnackType;
    },
    isErrorSnack() {
      return this.snackType === "error";
    },
  },
  methods: {
    close() {
      this.$store.commit("resetSnack");
    },
  },
};
</script>
<style lang="scss" scoped>
.snack-container {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 101;
  &.error {
    .snack-wrapper {
      background: $red;
      box-shadow: 0px 51px 69px rgba(23, 18, 43, 0.585739);
      backdrop-filter: blur(11px);
    }
    .snack {
      background: transparent;
      .snack-icon {
        svg {
          path {
            fill: white;
          }
        }
      }
      .snack-close {
        &:hover {
          svg {
            path {
              fill: $text-type-0;
            }
          }
          .close-text {
            color: $text-type-0;
          }
        }
        svg {
          path {
            fill: white;
          }
        }
        .close-text {
          color: white;
        }
      }
    }
  }
  .snack-wrapper {
    background: linear-gradient(180deg, rgba(16, 14, 42, 0) 0%, #100e2a 100%);
    backdrop-filter: blur(11px);
    //opacity: 0.5;
    position: fixed; /* Sit on top of the screen */
    z-index: 1050; /* Add a z-index if needed */
    bottom: 60px; /* 30px from the bottom */
    /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
    However, delay the fade out process for 2.5 seconds */
    -webkit-animation: fadein 0.5s, fadeout 0.5s 4.5s;
    animation: fadein 0.5s, fadeout 0.5s 4.5s;
    min-width: 620px;
    border-radius: 10px;
  }
  .snack {
    //opacity: 1;
    //z-index: 1050; /* Add a z-index if needed */
    padding: 18px;
    display: flex;
    align-items: center;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    //box-shadow: 0px 51px 69px rgba(23, 18, 43, 0.585739);
    //backdrop-filter: blur(23px);
    /* Note: backdrop-filter has minimal browser support */
    border-radius: 8px;
    .snack-icon {
      display: flex;
      margin-right: 22px;
      svg {
        width: 36px;
        path {
          fill: $purple;
        }
      }
    }
    .snack-text {
      flex: 1;
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      /* White */
      color: white;
    }
    .snack-close {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      &:hover {
        svg {
          path {
            fill: white;
          }
        }
        .close-text {
          color: white;
        }
      }
      svg {
        width: 24px;
        path {
          fill: #8786ab;
        }
      }
      .close-text {
        font-weight: 600;
        font-size: 8px;
        line-height: 10px;
        text-align: center;
        text-transform: uppercase;
        /* Text/type2 */
        color: $text-type-2;
      }
    }
  }
}
/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 60px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 60px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 60px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 60px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
@media (max-width: 600px) {
  .snack-container {
    .snack-wrapper {
      min-width: auto;
      width: calc(100% - 48px);
      bottom: 24px;
      .snack {
        .snack-text {
          font-size: 14px;
        }
      }
    }
  }
  //.signup-wizard {
  //  .back {
  //    top: 24px;
  //    left: 24px;
  //  }
  //}
}
</style>
